<script setup lang="ts">
    import { useAppStore } from '@/js/stores/app';
    import { computed } from 'vue';
    import { __ } from '@/js/stores/expressions';
    import SelectInput from '../SelectInput.vue';
    import InputLabel from '../InputLabel.vue';
    const app = useAppStore();

    const LANGUAGE_OPTIONS = computed(() => ({
        sv: { value: 'sv', name: __('swedish') },
        en: { value: 'en', name: __('english') },
        no: { value: 'no', name: __('norwegian') },
        da: { value: 'da', name: __('danish') },
        fi: { value: 'fi', name: __('finnish') },
    }));
</script>
<template>
    <InputLabel for="select-language">
        {{ __('language') }}
    </InputLabel>
    <SelectInput id="select-language" v-model="app.language">
        <option
            v-for="option in Object.values(LANGUAGE_OPTIONS)"
            :key="option.value"
            :value="option.value"
            :selected="app.language === option.value"
        >
            {{ option.name }}
        </option>
    </SelectInput>
</template>
